import {
    createReducer,
    createActionResources
  } from "redux-waiters";
  import { RESET_REDUCER } from "../constants";
  
  export const searchProductsAction = createActionResources("products/search");

  const initialState = {
    fetching: false,
    products: [],
    total: 0,
    totalPages: 0,
    pageNumber: 1,
    error: {},
  };
  
  export default createReducer(
    {
      [searchProductsAction.start]: state => {
        return { ...state, fetching: true };
      },
      [searchProductsAction.success]: (state, action) => {
        return {
          ...state,
          products: action.data?.content,
          pageNumber: action.data?.pageNumber + 1,
          total: action.data?.total,
          totalPages: Math.ceil(action.data?.total / action.data?.pageSize),
          fetching: false,
        };
      },
      [searchProductsAction.error]: state => {
        return { ...state, fetching: false };
      },
  
      [RESET_REDUCER]: () => initialState,
    },
    initialState
  );